import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataEmployee } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_EMPLOYEE = defineMasterdataEntity<MasterdataEmployee>({
  name: 'employee',
  responseKey: 'employees',
  displayWith: (e) => {
    const person = [e.lastName, e.firstName].filter(Boolean).join(' ') || e.name;
    return keyName(e.key, person);
  },
  secondaryWith: (e) => [e.zipCode, e.city].filter(Boolean).join(' ') || null,
  icon: 'fa-regular fa-user',
  title: 'Dienstnehmersuche',
  label: 'Dienstnehmer',
  placeholder: 'Dienstnehmer suchen...',
  columns: [
    {
      label: 'Dienstnehmer',
      type: 'entity',
      icon: 'fa-regular fa-user',
      value: (e) => {
        const person =
          [e.lastName, e.firstName].filter(Boolean).join(' ') || e.name;
        return keyName(e.key, person);
      },
      secondary: (e) => [e.zipCode, e.city].filter(Boolean).join(' ') || null,
    },
    { label: 'Schlüssel', value: (e) => e.key },
    { label: 'Bezeichnung', value: (e) => e.name },
    { label: 'Vorname', value: (e) => e.firstName },
    { label: 'Nachname', value: (e) => e.lastName },
    { label: 'Geburtsname', value: (e) => e.maidenName },
    { label: 'Straße', value: (e) => e.street },
    { label: 'PLZ', value: (e) => e.zipCode },
    { label: 'Ort', value: (e) => e.city },
    { label: 'Geburtsdatum', value: (e) => e.dateOfBirth },
    { label: 'Spindnummer', value: (e) => e.lockerNumber },
    { label: 'Leiharbeiter', value: (e) => (e.temporaryWorker ? 'Ja' : 'Nein') },
    { label: 'Arbeitszeitmodell', value: (e) => e.workRecord?.name ?? null },
    { label: 'Teilzeit', value: (e) => (e.partTime ? 'Ja' : 'Nein') },
    { label: 'Beruf', value: (e) => e.occupation },
  ],
});
